import { render, staticRenderFns } from "./BaseSlider.vue?vue&type=template&id=37f20323"
import script from "./BaseSlider.vue?vue&type=script&lang=js"
export * from "./BaseSlider.vue?vue&type=script&lang=js"
import style0 from "./BaseSlider.vue?vue&type=style&index=0&id=37f20323&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports